import styled from 'styled-components';

export const SearchContainer = styled.div`
  margin: 30px 0;
  display: flex;
  @media only screen and (min-width: 426px) and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const SearchDetail = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.textColor};
  padding-top: 38px;
  @media only screen and (min-width: 426px) and (max-width: 991px) {
    padding: 12px 0;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const SearchWrapper = styled.div`
  width: 45%;
  @media only screen and (min-width: 426px) and (max-width: 768px) {
    width: 100%;
  }
`;

export const FilterSorter = styled.div`
  width: 55%;
  @media only screen and (min-width: 426px) and (max-width: 768px) {
    width: 100%;
  }
`;

export const SearchHead = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  line-height: ${props => props.theme.lineHeight.primary};
  margin-right: 10px;
  vertical-align: middle;
  @media only screen and (min-width: 320px) and (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const Sort = styled.div`
  display: inline-block;
`;

export const View = styled.div`
  display: flex;
`;

export const Sorter = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Filter = styled.div`
  margin-top: 30px;
`;
